import { createSlice } from '@reduxjs/toolkit';

export interface ITool {
    name: string;
    icon: string | {};
    title: string;
}

export interface conciergeSliceState {
    visible: boolean;
    closeChat: boolean;
    onlySearch: boolean;
    fromSearch: boolean;
    width: number;
    newChat: string | null;
    availableTools: ITool[];
    selectedTools: string[];
    focusInput: boolean;
}

export const conciergeSlice = createSlice({
    name: 'concierge',
    initialState: {
        visible: false,
        closeChat: false,
        width: 420,
        newChat: null,
        onlySearch: false,
        fromSearch: false,
        availableTools: [],
        selectedTools: [],
        focusInput: false,
    } as conciergeSliceState,
    reducers: {
        show: (state) => {
            state.visible = true;
        },
        hide: (state) => {
            state.visible = false;
        },
        toggleVisibility: (state) => {
            state.visible = !state.visible;
        },
        setConciergeWidgetWidth: (state, action) => {
            state.width = action.payload;
        },
        startNewChat: (state, action) => {
            state.newChat = action.payload;
        },
        clearNewChat: (state) => {
            state.newChat = null;
        },
        closeChat: (state, action) => {
            state.closeChat = action.payload;
        },
        setOnlySearch: (state, action) => {
            state.onlySearch = action.payload;
        },
        setAvailableTools: (state, action) => {
            state.availableTools = action.payload;
        },
        setSelectedTools: (state, action) => {
            state.selectedTools = action.payload;
            state.focusInput = !state.focusInput;
        },
        triggerInputFocus: (state) => {
            state.focusInput = !state.focusInput;
        },
        setFromSearch: (state, action) => {
            state.fromSearch = action.payload;
        },
    },
});

export const {
    show,
    hide,
    toggleVisibility,
    setConciergeWidgetWidth,
    startNewChat,
    clearNewChat,
    closeChat,
    setOnlySearch,
    setAvailableTools,
    setSelectedTools,
    triggerInputFocus,
    setFromSearch,
} = conciergeSlice.actions;

export default conciergeSlice.reducer;
